<template>
  <div class="ad-fo-111">
    <table class="header-table">
      <tbody>
        <tr>
          <td class="logo-cell">
            <v-img v-if="logoUrl" :src="logoUrl" max-height="55" contain />
            <span v-else class="text-caption grey--text">Logo empresa</span>
          </td>
          <td class="title-cell">
            <div class="title-text">Revisión de 17 puntos de seguridad</div>
            <v-chip small outlined color="white" class="font-weight-bold mt-1">
              {{ tipoRevision === 'salida' ? 'Revisión de salida' : 'Revisión de entrada' }}
            </v-chip>
          </td>
          <td class="meta-cell">
            <table class="meta-inner">
              <tbody>
                <tr><td><strong>CÓDIGO:</strong> {{ documento.codigo }}</td></tr>
                <tr><td><strong>REVISIÓN:</strong> {{ documento.revision }}</td></tr>
                <tr><td><strong>FECHA:</strong> {{ documento.fecha_formato }}</td></tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <v-alert v-if="errorMessage" type="error" outlined dense class="my-3">
      {{ errorMessage }}
    </v-alert>

    <table class="three-col-table">
      <tbody>
        <tr>
          <!-- OPERADOR -->
          <td class="col-cell">
            <table class="section-table">
              <tbody>
                <tr><th colspan="2" class="section-header">Operador</th></tr>
                <tr v-if="operadorNombreDisplay">
                  <td colspan="2" class="static-field">
                    <div class="field-label">Nombre</div>
                    <div class="field-value">{{ operadorNombreDisplay }}</div>
                    <div v-if="operadorNumeroEmpleadoDisplay" class="field-sub">
                      No. empleado: {{ operadorNumeroEmpleadoDisplay }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="input-field">
                    <v-text-field
                      v-model="form.operador.tipo_identificacion"
                      label="Tipo de identificación"
                      outlined dense hide-details
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="input-field">
                    <v-text-field
                      v-model="form.operador.numero_licencia"
                      label="Número de licencia"
                      outlined dense hide-details
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="input-field">
                    <v-text-field
                      v-model="form.operador.telefono_adicional"
                      label="Teléfono adicional"
                      outlined dense hide-details
                    />
                  </td>
                </tr>
                <tr>
                  <td class="check-label">Chaleco barras reflejantes</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.operador.chaleco_reflejante" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
                <tr>
                  <td class="check-label">Zapato de seguridad</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.operador.zapato_seguridad" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
                <tr>
                  <td class="check-label">Pantalón largo</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.operador.pantalon_largo" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          <!-- UNIDAD -->
          <td class="col-cell">
            <table class="section-table">
              <tbody>
                <tr><th colspan="2" class="section-header">Unidad</th></tr>
                <tr v-for="f in unidadFields" :key="f.key">
                  <td class="check-label">{{ f.label }}</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.unidad[f.key]" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>

          <!-- DOCUMENTOS -->
          <td class="col-cell">
            <table class="section-table">
              <tbody>
                <tr><th colspan="2" class="section-header">Documentos</th></tr>
                <tr>
                  <td class="check-label">Carta porte</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.documentos.carta_porte" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
                <tr>
                  <td class="check-label">Carta de instrucciones</td>
                  <td class="check-box">
                    <v-checkbox v-model="form.documentos.carta_instrucciones" hide-details dense class="ma-0 pa-0" />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Datos de vehículo -->
    <table class="vehiculo-table">
      <tbody>
        <tr><th colspan="4" class="section-header">Datos de vehículo</th></tr>
        <tr>
          <td>
            <v-text-field v-model="form.vehiculo.placas_unidad" label="Placas unidad" outlined dense hide-details />
          </td>
          <td>
            <v-text-field v-model="form.vehiculo.placas_caja" label="Placas caja" outlined dense hide-details />
          </td>
          <td colspan="2">
            <div class="field-label mb-1">Tipo de vehículo</div>
            <v-radio-group v-model="form.vehiculo.tipo" row hide-details class="mt-0 mb-0 tipo-veh-group">
              <v-radio label="Tracto" value="Tracto" />
              <v-radio label="Plataforma" value="Plataforma" />
              <v-radio label="Torton" value="Torton" />
              <v-radio label="Otro" value="Otro" />
            </v-radio-group>
            <v-text-field
              v-if="form.vehiculo.tipo === 'Otro'"
              v-model="form.vehiculo.tipo_otro_texto"
              label="Especifique"
              outlined dense hide-details
              class="mt-2"
            />
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="form.vehiculo.numero_economico" label="Número económico" outlined dense hide-details />
          </td>
          <td>
            <v-text-field v-model="form.vehiculo.sello_1" label="Número de sello 1" outlined dense hide-details />
          </td>
          <td>
            <v-text-field v-model="form.vehiculo.sello_2" label="Número de sello 2" outlined dense hide-details />
          </td>
          <td>
            <v-text-field v-model="form.vehiculo.nombre_transporte" label="Nombre línea de transporte" outlined dense hide-details />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Diagrama del camión -->
    <div class="diagram-box">
      <div class="diagram-title">Puntos de revisión de unidades</div>
      <v-img v-if="diagramaUrl" :src="diagramaUrl" max-height="240" contain class="mx-auto" />
      <div class="diagram-legend">
        <div class="legend-col" v-for="grupo in diagramaLeyenda" :key="grupo[0].n">
          <div v-for="pt in grupo" :key="pt.n" class="legend-item">
            <strong class="legend-num">{{ pt.n }}.-</strong> {{ pt.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="insp-wrap">
      <div class="section-header insp-title">Puntos de inspección</div>

      <v-alert v-if="anomaliasDetectadas.length" type="warning" outlined dense class="anomalia-alert ma-2">
        <v-icon small color="warning" class="mr-1">warning</v-icon>
        <strong>Se detectaron {{ anomaliasDetectadas.length }} anomalía(s)</strong>
        en el/los punto(s) {{ anomaliasDetectadas.map(a => a.numero).join(', ') }}.
        Se notificará automáticamente a los supervisores al guardar esta revisión.
      </v-alert>

      <div v-if="loadingPuntos" class="text-center pa-6">
        <v-progress-circular indeterminate color="primary" />
        <div class="text-caption grey--text mt-2">Cargando puntos de inspección…</div>
      </div>

      <div v-else-if="loadingPuntosError" class="pa-4">
        <v-alert type="error" outlined dense class="mb-2">{{ loadingPuntosError }}</v-alert>
        <v-btn small color="primary" outline @click="fetchPuntos">Reintentar</v-btn>
      </div>

      <table v-else class="insp-table">
        <thead>
          <tr>
            <th rowspan="2" class="no-col-h">No.</th>
            <th rowspan="2" class="punto-col-h">Puntos de inspección</th>
            <th colspan="3">Cumple</th>
            <th rowspan="2" class="obs-col-h">Observaciones</th>
          </tr>
          <tr>
            <th class="mini-h">Sí</th>
            <th class="mini-h">No</th>
            <th class="mini-h">N/A</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in form.inspeccion" :key="item.punto_id" :class="{ 'row-anomalia': esAnomalia(item) }">
            <td class="no-col" :class="{ highlight: highlightRows.includes(item.numero) }">{{ item.numero }}</td>
            <td class="punto-col">{{ item.descripcion }}</td>
            <td colspan="3" class="cumple-col">
              <v-radio-group v-model="item.cumple" row dense hide-details class="my-0 py-1 insp-radios">
                <v-radio label="Sí" value="si" />
                <v-radio label="No" value="no" />
                <v-radio label="N/A" value="na" />
              </v-radio-group>
              <div v-if="esAnomalia(item)" class="anomalia-flag">
                <v-icon x-small color="error">warning</v-icon>
                Anomalía: se notificará a supervisores
                <div class="evidencia-row">
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    :ref="'fileInput_' + item.punto_id"
                    style="display:none"
                    @change="onEvidenciaChange(item, $event)"
                  />
                  <v-btn
                    x-small
                    icon
                    outlined
                    color="error"
                    class="evidencia-btn"
                    title="Tomar/adjuntar evidencia de la anomalía"
                    @click="triggerEvidencia(item)"
                  >
                    <v-icon small>camera_alt</v-icon>
                  </v-btn>
                  <span v-if="item.evidenciaNombre" class="evidencia-nombre" :title="item.evidenciaNombre">
                    {{ item.evidenciaNombre }}
                  </span>
                  <v-img
                    v-if="item.evidenciaPreview"
                    :src="item.evidenciaPreview"
                    max-height="36"
                    max-width="36"
                    contain
                    class="evidencia-thumb"
                  />
                  <v-btn
                    v-if="item.evidenciaPreview"
                    x-small
                    icon
                    title="Quitar evidencia"
                    @click="quitarEvidencia(item)"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
            <td class="obs-col">
              <v-text-field v-model="item.observaciones" dense hide-details single-line />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Firma del vigilante -->
    <table class="firma-table">
      <tbody>
        <tr>
          <td class="firma-cell">
            <v-text-field v-model="form.firma_vigilante_nombre" label="Nombre del vigilante" outlined dense hide-details />
            <div class="firma-line">Nombre y firma del vigilante</div>
          </td>
        </tr>
      </tbody>
    </table>

    <v-alert type="warning" outlined dense class="mt-3">
      <strong>NOTA:</strong> avisar de manera inmediata al jefe de almacén si alguno de los puntos anteriores no cumple.
    </v-alert>

    <v-row justify="end" class="mt-4">
      <v-btn color="primary" :loading="enviando" :disabled="loadingPuntos" @click="enviar">
        Guardar revisión
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RevisionDiecisietePuntos',

  props: {
    shippingWindowId: { type: String, required: true },
    tipoRevision: { type: String, default: 'entrada' },
    vigilanteId: { type: [String, Number], required: true },
    authToken: { type: String, required: true },
    apiBase: { type: String, default: 'https://empresa-service.intrare.app' },
    puntosPath: { type: String, default: '/shipments/security/puntos/' },
    submitPath: { type: String, default: '/shipments/security/revisiones/guard/complete/' },
    logoUrl: { type: String, default: '' },
    diagramaUrl: { type: String, default: '' },
    operadorNombreDisplay: { type: String, default: '' },
    operadorNumeroEmpleadoDisplay: { type: String, default: '' },
    prefillData: { type: Object, default: () => ({}) },
    documentoMeta: {
      type: Object,
      default: () => ({ codigo: 'AD-FO-111', revision: '00', fecha_formato: '' })
    }
  },

  data() {
    return {
      enviando: false,
      loadingPuntos: false,
      loadingPuntosError: '',
      errorMessage: '',
      documento: this.documentoMeta,

      unidadFields: [
        { key: 'sello_unidad', label: 'Sello de unidad' },
        { key: 'polizas_seguro', label: 'Pólizas de seguro' },
        { key: 'medios_sujecion', label: 'Medios de sujeción' },
        { key: 'unidad_limpia', label: 'Unidad limpia' },
        { key: 'piso_madera', label: 'Piso de madera' },
        { key: 'sello_botella', label: 'Sello de botella' }
      ],

      highlightRows: [11, 13, 14, 16, 17],

      diagramaLeyenda: [
        [
          { n: 1, label: 'Defensa' },
          { n: 2, label: 'Motor' },
          { n: 3, label: 'Llantas' },
          { n: 4, label: 'Piso (del camión)' }
        ],
        [
          { n: 5, label: 'Tanque de combustible' },
          { n: 6, label: 'Cabina' },
          { n: 7, label: 'Tanque de aire' },
          { n: 8, label: 'Ejes de acción' }
        ],
        [
          { n: 9, label: 'Llanta de repuesto' },
          { n: 10, label: 'Exteriores/tren de rodaje' },
          { n: 11, label: 'Puertas por dentro/fuera' },
          { n: 12, label: 'Piso (de la caja)' },
          { n: 13, label: 'Paredes laterales' }
        ],
        [
          { n: 14, label: 'Pared frontal' },
          { n: 15, label: 'Techo' },
          { n: 16, label: 'Unidad de refrigeración' },
          { n: 17, label: 'Escape' }
        ]
      ],

      form: {
        operador: {
          tipo_identificacion: this.prefillData.operador_tipo_identificacion || '',
          numero_licencia: this.prefillData.operador_numero_licencia || '',
          telefono_adicional: this.prefillData.operador_telefono_adicional || '',
          chaleco_reflejante: false,
          zapato_seguridad: false,
          pantalon_largo: false
        },

        unidad: {
          sello_unidad: false,
          polizas_seguro: false,
          medios_sujecion: false,
          unidad_limpia: false,
          piso_madera: false,
          sello_botella: false
        },

        documentos: {
          carta_porte: false,
          carta_instrucciones: false
        },

        vehiculo: {
          placas_unidad: this.prefillData.vehiculo_placas_unidad || '',
          placas_caja: this.prefillData.vehiculo_placas_caja || '',
          tipo: '',
          tipo_otro_texto: '',
          numero_economico: this.prefillData.vehiculo_numero_economico || '',
          sello_1: this.prefillData.vehiculo_sello_1 || '',
          sello_2: this.prefillData.vehiculo_sello_2 || '',
          nombre_transporte: this.prefillData.vehiculo_nombre_transporte || ''
        },

        inspeccion: [],

        firma_vigilante_nombre: this.prefillData.firma_vigilante_nombre || ''
      }
    }
  },

  created() {
    const knownTypes = ['Tracto', 'Plataforma', 'Torton']
    const prefillTipo = this.prefillData.vehiculo_tipo || ''
    if (prefillTipo && knownTypes.indexOf(prefillTipo) === -1) {
      this.form.vehiculo.tipo = 'Otro'
      this.form.vehiculo.tipo_otro_texto = prefillTipo
    } else {
      this.form.vehiculo.tipo = prefillTipo
    }
    this.fetchPuntos()
  },

  computed: {
    anomaliasDetectadas() {
      return this.form.inspeccion.filter(item => this.esAnomalia(item))
    }
  },

  beforeDestroy() {
    this.form.inspeccion.forEach(item => {
      if (item.evidenciaPreview) URL.revokeObjectURL(item.evidenciaPreview)
    })
  },

  methods: {
    esAnomalia(item) {
      return item.cumple === 'no' || item.cumple === 'na'
    },

    // Evidencia fotográfica: solo estado visual local, no forma parte del payload enviado a la API
    triggerEvidencia(item) {
      const refKey = 'fileInput_' + item.punto_id
      const el = this.$refs[refKey]
      const input = Array.isArray(el) ? el[0] : el
      if (input) input.click()
    },

    onEvidenciaChange(item, event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file) return
      if (item.evidenciaPreview) URL.revokeObjectURL(item.evidenciaPreview)
      this.$set(item, 'evidenciaFile', file)
      this.$set(item, 'evidenciaNombre', file.name)
      this.$set(item, 'evidenciaPreview', URL.createObjectURL(file))
    },

    quitarEvidencia(item) {
      if (item.evidenciaPreview) URL.revokeObjectURL(item.evidenciaPreview)
      this.$set(item, 'evidenciaFile', null)
      this.$set(item, 'evidenciaNombre', '')
      this.$set(item, 'evidenciaPreview', '')
    },

    fetchPuntos() {
      this.loadingPuntos = true
      this.loadingPuntosError = ''
      axios.get(this.apiBase + this.puntosPath, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + this.authToken
        }
      })
        .then(response => {
          const puntos = (response.data || [])
            .filter(p => p.activo !== false)
            .sort((a, b) => a.numero - b.numero)
          this.form.inspeccion = puntos.map(p => ({
            punto_id: p.id,
            numero: p.numero,
            descripcion: p.descripcion,
            cumple: null,
            observaciones: ''
          }))
          this.loadingPuntos = false
        })
        .catch(() => {
          this.loadingPuntos = false
          this.loadingPuntosError = 'No se pudieron cargar los puntos de inspección.'
        })
    },

    vehiculoTipoFinal() {
      return this.form.vehiculo.tipo === 'Otro' ? this.form.vehiculo.tipo_otro_texto : this.form.vehiculo.tipo
    },

    // Arma el payload EXACTAMENTE con la estructura que espera
    // POST /security/revisiones/guard/complete/
    buildPayload() {
      return {
        shipping_window_id: this.shippingWindowId,
        tipo_revision: this.tipoRevision,
        vigilante_id: this.vigilanteId,

        operador_tipo_identificacion: this.form.operador.tipo_identificacion,
        operador_numero_licencia: this.form.operador.numero_licencia,
        operador_telefono_adicional: this.form.operador.telefono_adicional,

        operador_chaleco_reflejante: this.form.operador.chaleco_reflejante,
        operador_zapato_seguridad: this.form.operador.zapato_seguridad,
        operador_pantalon_largo: this.form.operador.pantalon_largo,

        vehiculo_placas_unidad: this.form.vehiculo.placas_unidad,
        vehiculo_placas_caja: this.form.vehiculo.placas_caja,
        vehiculo_tipo: this.vehiculoTipoFinal(),
        vehiculo_numero_economico: this.form.vehiculo.numero_economico,
        vehiculo_sello_1: this.form.vehiculo.sello_1,
        vehiculo_sello_2: this.form.vehiculo.sello_2,
        vehiculo_nombre_transporte: this.form.vehiculo.nombre_transporte,

        documento_carta_porte: this.form.documentos.carta_porte,
        documento_carta_instrucciones: this.form.documentos.carta_instrucciones,

        unidad_sello_unidad: this.form.unidad.sello_unidad,
        unidad_polizas_seguro: this.form.unidad.polizas_seguro,
        unidad_medios_sujecion: this.form.unidad.medios_sujecion,
        unidad_limpia: this.form.unidad.unidad_limpia,
        unidad_piso_madera: this.form.unidad.piso_madera,
        unidad_sello_botella: this.form.unidad.sello_botella,

        firma_vigilante_nombre: this.form.firma_vigilante_nombre,

        puntos: this.form.inspeccion.map(item => ({
          punto_id: item.punto_id,
          cumple: item.cumple,
          observaciones: item.observaciones || ''
        }))
      }
    },

    validate() {
      this.errorMessage = ''
      if (!this.form.inspeccion.length) {
        this.errorMessage = 'No hay puntos de inspección cargados.'
        return false
      }
      const faltantes = this.form.inspeccion.filter(item => !item.cumple)
      if (faltantes.length > 0) {
        this.errorMessage = 'Faltan por responder los puntos: ' + faltantes.map(f => f.numero).join(', ')
        return false
      }
      return true
    },

    parseError(error) {
      const data = error.response && error.response.data
      if (!data) return 'Ocurrió un error al guardar la revisión de 17 puntos.'
      if (data.error) return data.error
      if (data.detail) return data.detail
      if (data.shipping_window_id) return Array.isArray(data.shipping_window_id) ? data.shipping_window_id.join(' ') : String(data.shipping_window_id)
      if (data.puntos) return Array.isArray(data.puntos) ? data.puntos.join(' ') : String(data.puntos)
      return 'Ocurrió un error al guardar la revisión de 17 puntos.'
    },

    async enviar() {
      if (!this.validate()) return
      this.enviando = true
      this.errorMessage = ''
      try {
        const payload = this.buildPayload()
        const response = await axios.post(this.apiBase + this.submitPath, payload, {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + this.authToken
          }
        })
        this.$emit('submitted', response.data)
      } catch (error) {
        const message = this.parseError(error)
        this.errorMessage = message
        this.$emit('error', message)
      } finally {
        this.enviando = false
      }
    }
  }
}
</script>

<style scoped>
.ad-fo-111 {
  font-size: 0.8rem;
  color: #1a1a1a;
}

/* ---------- Tablas base ---------- */
.ad-fo-111 table {
  border-collapse: collapse;
  width: 100%;
}
.section-header {
  background-color: #2f6fb0;
  color: #fff;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 0.8rem;
  padding: 6px 10px;
  text-align: center;
}

/* ---------- Encabezado ---------- */
.header-table {
  border: 1.5pt solid #000;
  margin-bottom: 10px;
}
.header-table > tbody > tr > td {
  border-right: 1pt solid #000;
  vertical-align: middle;
  padding: 8px;
}
.header-table > tbody > tr > td:last-child { border-right: none; }
.logo-cell { width: 18%; text-align: center; }
.title-cell { width: 57%; text-align: center; }
.title-text {
  font-size: 1.15rem;
  font-weight: bold;
  text-transform: uppercase;
}
.meta-cell { width: 25%; padding: 0 !important; }
.meta-inner td {
  border-bottom: 1pt solid #000;
  padding: 4px 8px;
  font-size: 0.72rem;
}
.meta-inner tr:last-child td { border-bottom: none; }

/* ---------- Tres columnas: Operador / Unidad / Documentos ---------- */
.three-col-table { border-spacing: 8px 0; margin-bottom: 10px; }
.col-cell { width: 33.33%; vertical-align: top; }
.section-table {
  border: 1pt solid #000;
  width: 100%;
}
.section-table td {
  border-top: 1pt solid #ccc;
  padding: 4px 8px;
  font-size: 0.75rem;
}
.section-table tr:nth-child(2) td { border-top: none; }
.field-label { font-weight: bold; font-size: 0.7rem; text-transform: uppercase; color: #444; }
.field-value { font-weight: bold; }
.field-sub { font-size: 0.68rem; color: #666; }
.input-field { padding: 6px 8px !important; }
.check-label { width: 72%; font-weight: 600; }
.check-box {
  width: 28%;
  text-align: center;
  border-left: 1pt solid #ccc;
}

/* ---------- Datos de vehículo ---------- */
.vehiculo-table {
  border: 1pt solid #000;
  margin-bottom: 10px;
}
.vehiculo-table th { padding: 6px; }
.vehiculo-table td {
  border: 1pt solid #ccc;
  padding: 6px 8px;
  width: 25%;
  vertical-align: top;
  font-size: 0.75rem;
}
.tipo-veh-group >>> .v-input--radio-group__input { flex-wrap: wrap; }

/* ---------- Diagrama ---------- */
.diagram-box {
  border: 1pt solid #000;
  padding: 14px;
  text-align: center;
  margin-bottom: 10px;
}
.diagram-title {
  font-size: 1rem;
  font-weight: bold;
  color: #c0392b;
  margin-bottom: 10px;
}
.diagram-legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 12px;
  text-align: left;
}
.legend-col { width: 25%; min-width: 160px; padding: 0 6px; }
.legend-item { font-size: 0.72rem; margin-bottom: 3px; }
.legend-num { color: #c0392b; }

/* ---------- Tabla de inspección ---------- */
.insp-wrap { border: 1pt solid #000; margin-bottom: 10px; }
.insp-title { border-bottom: 1pt solid #000; }
.insp-table th {
  background-color: #2f6fb0;
  color: #fff;
  border: 1pt solid #1c4a78;
  padding: 6px;
  font-size: 0.72rem;
  text-transform: uppercase;
}
.insp-table .mini-h { width: 6%; }
.insp-table td {
  border: 1pt solid #ccc;
  padding: 4px 8px;
  font-size: 0.75rem;
  vertical-align: middle;
}
.no-col-h { width: 4%; }
.punto-col-h { width: 34%; }
.obs-col-h { width: auto; }
.no-col {
  text-align: center;
  font-weight: bold;
  background-color: #ddeaf6;
  width: 4%;
}
.no-col.highlight { background-color: #f4a460; }
.punto-col { font-weight: 600; width: 34%; }
.cumple-col { text-align: center; }
.insp-radios { justify-content: center; }
.obs-col { min-width: 180px; }
.row-anomalia { background-color: #fdecea; }
.row-anomalia .no-col:not(.highlight) { background-color: #f8d7d7; }
.anomalia-flag {
  color: #c0392b;
  font-weight: 600;
  font-size: 0.68rem;
  margin-top: -2px;
}
.anomalia-alert { font-size: 0.78rem; }

/* ---------- Evidencia de anomalía (solo visual) ---------- */
.evidencia-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;
  flex-wrap: wrap;
}
.evidencia-btn { border: 1pt solid #c0392b; }
.evidencia-nombre {
  font-size: 0.65rem;
  font-weight: 500;
  color: #444;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.evidencia-thumb {
  border: 1pt solid #c0392b;
  border-radius: 3px;
}

/* ---------- Firma ---------- */
.firma-table { margin-bottom: 6px; }
.firma-cell { max-width: 420px; margin: 0 auto; text-align: center; }
.firma-line {
  border-top: 1pt solid #000;
  margin-top: 26px;
  padding-top: 4px;
  font-size: 0.75rem;
  font-weight: bold;
}

@media (max-width: 960px) {
  .three-col-table, .three-col-table > tbody, .three-col-table > tbody > tr,
  .col-cell {
    display: block;
    width: 100%;
  }
  .col-cell { margin-bottom: 10px; }
  .header-table > tbody > tr,
  .header-table > tbody > tr > td {
    display: block;
    width: 100% !important;
    border-right: none;
    border-bottom: 1pt solid #000;
    text-align: center;
  }
  .vehiculo-table tr, .vehiculo-table td { display: block; width: 100% !important; }
  .legend-col { width: 50%; }
}
</style>